export default __webpack_public_path__ + "media/transfer_window/upsell-macapp-17da3a98.png";